import { Accordion, Group, Loader, createStyles } from '@mantine/core';

import { Text } from '~/domains/design-system/Text';

const useStyles = createStyles((theme) => ({
  item: {
    borderColor: theme.colors.gray2[0],
    borderRadius: `${theme.other.spacing._8}px !important`,
    pointerEvents: 'none',
    opacity: 0.7,

    '&, &[data-active], &:hover': {
      backgroundColor: theme.white,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.other.spacing._40,
  },
  control: {
    padding: `${theme.other.spacing._16} ${theme.other.spacing._8}`,
    '&, &:hover': { background: 'transparent' },
  },
  controlContent: {
    display: 'flex',

    [theme.fn.smallerThan('md')]: {
      flexDirection: 'column',
      gap: theme.other.spacing._16,
    },
  },
  heading: {
    width: '150px',

    [theme.fn.smallerThan('md')]: {
      width: '100%',
      flexGrow: 1,
    },
  },
  labels: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.other.spacing._4,
    alignItems: 'center',
    justifyContent: 'center',

    [theme.fn.smallerThan('md')]: {
      justifyContent: 'start',
    },
  },
  chevron: {
    width: '100px',
    justifyContent: 'end',
  },
  badge: {
    backgroundColor: theme.colors.gray2[0],
    borderRadius: '100em',
    padding: `${theme.other.spacing._2}px ${theme.other.spacing._12}px`,
    fontSize: '14px',
    fontWeight: 500,
  },
}));

interface AccordionLoadingElementProps {
  title: string;
  showLoadingLabel?: boolean;
}

export function AccordionLoadingElement({ title, showLoadingLabel }: AccordionLoadingElementProps) {
  const { classes } = useStyles();

  return (
    <Group>
      <Accordion
        w="100%"
        variant="contained"
        disableChevronRotation
        chevron={<Loader size={16} />}
        classNames={{
          item: classes.item,
          content: classes.content,
          control: classes.control,
          chevron: classes.chevron,
        }}
      >
        <Accordion.Item value="loading">
          <Accordion.Control>
            <div className={classes.controlContent}>
              <div className={classes.heading}>
                <Text variant="subhead-large">{title}</Text>
              </div>
              <div className={classes.labels}>
                {showLoadingLabel && <div className={classes.badge}>Loading...</div>}
              </div>
            </div>
          </Accordion.Control>
        </Accordion.Item>
      </Accordion>
    </Group>
  );
}
